 
import React from 'react';
import AttributeSection from './AttributeSection';

function Attributes({attributes, name, state, productId, handleSelection, sizeGuide}) {
    return (
        <>
            {attributes.map((attribute, index) => {
                return (
                    <AttributeSection
                        key={index}
                        name={name}
                        isFirst={index === 0}
                        values={attribute.values}
                        label={attribute.label}
                        selectedId={state[`${attribute.label}Id`]}
                        rows={index === 0 ? 2 : 3}
                        handleSelection={handleSelection}
                        productId={productId}
                        sizeGuide={sizeGuide}
                    />
                );
            })}
        </>
    );
}

export default Attributes;
